<template lang="pug">
    .drawer-container
        el-button(
            type="success"
            icon="el-icon-fa-list-alt far"
            size="large"
            @click="openDrawer"
        ) {{ $t('Article stocks') }}
        el-drawer.cash-book-drawer(
            :title="$t('Article stocks')"
            :visible.sync="drawer.visibility"
            :modal="true"
            size="50%"
            @close="handleClose"
        )
            .flex-row
                el-select(
                    v-model="stock"
                    valueKey="id"
                    placeholder=""
                    :disabled="!activePointOfSale.stocks || activePointOfSale.stocks.length <= 1"
                )
                    el-option(
                        v-for="item in activePointOfSale.stocks || []"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                    )
                //- p.label(v-if="activePointOfSale.stocks") Dieser Kasse zugeordnetes Lager: {{ activePointOfSale.stocks[0].name }}
                el-button(
                    icon="el-icon-fa-file-pdf fas"
                    type="success"
                    @click="handlePrintAricleStock"
                ) {{ $t('Generate article stock PDF') }}
            .drawer-body(v-loading="drawer.loading" @scroll="handleDrawerScroll")
                template(v-if="articleReports" )
                    template(v-if="!drawer.loading && articleReports.items.length == 0")
                        p.label {{ $t('No PDF documents with article stocks present.') }}
                    table.striped.is-full-width
                        tr(v-for="item in articleReports.items")
                            td.center.min
                                el-button.download-button(
                                    circle
                                    size="mini"
                                    type="info"
                                    icon="el-icon-fa-download fas"
                                    @click.stop.prevent="download(item)"
                                )
                                el-button.print-button(
                                    circle
                                    size="mini"
                                    type="info"
                                    icon="el-icon-fa-print fas"
                                    @click.stop.prevent="print(item)"
                                )
                            td {{ item.name }}
                            td.min {{ dateFormat(item.created_at) }}
</template>

<i18n>
    {
    "de": {
        "Article stocks": "Artikelbestände",
        "Generate article stock PDF": "Artikelbestand PDF generieren",
        "Close": "Schließen",
        "PDF generation started in background, you can check back later.": "PDF-Generierung wurde im Hintergrund gestartet. Sie können die Datei unter 'Artikelbestände' abrufen, sobald sie erstellt wurde.",
        "No PDF documents with article stocks present.": "Keine PDF-Dokumente mit Artikelbeständen vorhanden."
    }
}
</i18n>

<script>

import articleStockReportAPI from '../../store/api/articleStockReport';

import FileApi from '@/store/api/cms/file';
import AuthApi from '@/store/api/system/auth';

import { timestamp2date } from '@/filters';
import _ from 'lodash';
import echo from '@/echo';
import { usePosSetupStore } from '@/stores'

export default {
    name: 'ArticleStockDrawer',
    data() {
        return {
            drawer: {
                visibility: false,
                loading: false,
            },
            articleReports: {
                items: [],
                currentPage: 1,
                lastPage: 0
            },
        };
    },
    methods: {
        debouncedRefetch: _.debounce(function () {
            this.loadNew(1);
        }, 500),
        handleDrawerScroll(event) {
            const { target } = event;
            this.loadMoreIfNeeded(target)
        },
        loadMoreIfNeeded(target) {
            const currentPage = this.articleReports.currentPage;
            if (this.drawer.loading === false && this.articleReports.lastPage > currentPage) {

                let loadMore = false;
                const offset = 40;

                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight - offset) {
                    loadMore = true;
                }

                if (loadMore) {
                    this.loadNew(currentPage + 1);
                }
            }
        },
        loadNew(page) {
            this.articleReports.currentPage = page;
            const stocks = this.activePointOfSale.stocks || [];
            let obj = {
                pageInfo: {
                    perPage: 25,
                    currentPage: page,
                },
                filters: [
                    {
                        key: 'type',
                        match: 'articlestock-report'
                    }
                ],
            }
            if (stocks.length > 0) {
                obj.filters.push({
                    key: 'stock',
                    match: stocks[0].id
                })
            }
            this.drawer.loading = true;

            FileApi.fetchFilesPaginated(obj).then(data => {
                this.articleReports.lastPage = data.pageInfo.lastPage;
                this.drawer.loading = false;
                this.articleReports.items.push(...data.items);
            }).catch((err) => reject(err)).finally(() => {
                this.drawer.loading = false
            })
        },
        dateFormat(timestamp) {
            return timestamp2date(timestamp, this.$t('yyyy-MM-dd') + ', HH:mm')
        },
        download(item) {
            const storageRoute = _.trim(
                `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`,
                '/'
            );

            const token = AuthApi.getToken()

            const table = 'files';
            const link = `${storageRoute}/${table}/${item.id}/${encodeURIComponent(item.name)}?download&token=${token}`;

            let element = document.createElement('a');
            element.setAttribute('href', link);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();
            document.body.removeChild(element);
        },
        print(item) {
            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`, '/')
            let table = 'files'

            // const file = this.cashReport.file
            const token = AuthApi.getToken()
            const printable = `${storageRoute}/${table}/${item.id}/${item.name}?token=${token}`

            printJS({
                printable,
                onLoadingEnd: () => {
                    // Don't reset state here - wait for print dialog
                },
                onError: () => {
                    this.printing = false;
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Could not print the cash report PDF!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                },
                onPrintDialogClose: () => {
                    this.printing = false;
                }
            })
        },
        openDrawer() {
            this.drawer.loading = true;
            this.drawer.visibility = true;

            this.resetState();

            const stocks = this.activePointOfSale.stocks || [];
            stocks.forEach((stock) => {
                echo.client.private('stock.' + stock.id)
                    .listen('.articlestock-report-created', () => {
                        this.resetState();

                        this.drawer.loading = true;
                        this.loadNew(1);
                    });
            })

            this.loadNew(1)
        },
        resetState() {
            this.articleReports.items = []
            this.articleReports.currentPage = 1;
            this.articleReports.lastPage = 0;
        },
        handlePrintAricleStock() {
            this.drawer.loading = true;

            const stocks = this.activePointOfSale.stocks || [];
            if (stocks.length === 0) return

            articleStockReportAPI.createArticleStockReport(parseInt(stocks[0].id))
                .then(() => {
                    // this.articleReports.items = []
                    // this.articleReports.currentPage = 1;
                    // this.articleReports.lastPage = 0;

                    // this.debouncedRefetch();

                    // this.drawer.visibility = false

                    this.$notify.info({
                        title: this.$t('PDF generation started in background, you can check back later.'),
                        iconClass: 'fas el-icon-fa-info-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
                .catch((err) => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: err.message,
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
                .finally(() => {
                    this.drawer.loading = false;
                })
        },
        handleClose() {
            // this.activePointOfSale.stocks.forEach((stock) => {
            //     echo.client.private('stock.' + stock.id)
            //         .stopListening('.articlestock-report-created');
            // })
        }
    },
    computed: {
        posSetupStore() {
            return usePosSetupStore()
        },
        // connectedStock() {
        // console.log(JSON.stringify(this.activePointOfSale.stocks));
        // return this.activePointOfSale.stocks[0] //.find((element) => element.key == "default");
        // },
        stock: {
            get() {
                let name = "";
                if (this.activeStock.id) name = this.activeStock.name
                return name;
            },
            set(value) {
                let activeStock = _.find(this.activePointOfSale.stocks || [], stock => stock.name == value);
                this.posSetupStore.setActiveStock(activeStock)
            }
        },
        activePointOfSale() {
            return this.posSetupStore.activePointOfSale
        },
        activeStock() {
            return this.posSetupStore.activeStock
        },
        options() {
            return this.posSetupStore.options
        }
    },
    mounted() {
        this.articleReports.items = []

        // console.log("mounted")
        // this.activePointOfSale.stocks.forEach((stock) => {
        //     echo.client.private('stock.' + stock.id)
        //         .listen('.articlestock-report-created', purchase => {
        //             this.debouncedRefetch();
        //         });
        // })
    }
}
</script>

<style lang="sass" scoped>
.cash-book-drawer
    .drawer-body
        flex-grow: 1
        overflow: auto
        padding: 0
        max-height: calc(100vh - 66px) // - 69px

.label
    margin-left: 20px
    margin-bottom: 12px

.center
    text-align: center

.flex-row
    padding: 20px
    padding-top: 0

.is-full-width
    width: 100%

table.striped
    border-collapse: collapse
    td
        padding: 5px 10px
        &.min
            width: 1px
            white-space: nowrap
        &:first-child
            padding-left: 20px
        &:last-child
            padding-right: 20px

#body .drawer-body::v-deep .el-loading-mask
    background-color: rgba(255, 255, 255, 0.9)
</style>
